// extracted by mini-css-extract-plugin
export default {"containerGrid":"Footer_containerGrid__EH-NP","logo":"Footer_logo__P8EvI","BgColor":"Footer_BgColor__2peSY"};